export default __webpack_public_path__ + "static/Poppins-Regular-ab6122bd28174ddf9eebc19a0cacdb25.woff";